import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { ExpandSingle, Header3 } from "@activecollab/components";
import PropTypes from "prop-types";
import { makeGetUserSubtasksSelector, makeGetUserTasksSelector } from "~/store/selectors/selector.userTasks";

export const TeamTaskListItem = ({ id, name, membersIds, handleCollapsedTaskLists, isExpanded }) => {
  const getTeamTasks = useMemo(() => makeGetUserTasksSelector(id, membersIds), [id, membersIds]);
  const tasks = useSelector(getTeamTasks);

  const getTeamSubtasks = useMemo(() => makeGetUserSubtasksSelector(id, membersIds), [id, membersIds]);
  const subtasks = useSelector(getTeamSubtasks);
  return (
    <>
      <div className="tw-flex my_work_task_list tw-pt-2">
        <ExpandSingle
          expanded={isExpanded}
          onClick={handleCollapsedTaskLists}
          className="tw-mr-3 tw-ml-6 tw-cursor-pointer tw-text-theme-700"
        />
        <Header3 color="primary">
          {name} ({tasks.length + subtasks.length})
        </Header3>
      </div>
    </>
  );
};

TeamTaskListItem.propTypes = {
  id: PropTypes.number.isRequired,
  membersIds: PropTypes.array,
  name: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool,
  handleCollapsedTaskLists: PropTypes.func,
};
